import { useQuery } from "@tanstack/react-query";
import { axios } from "lib/axios";

export const getMemberGrowth = ({ churchId, fromDate, toDate, period }) => {
  return axios.get(
    `/churches/${churchId}/dashboard/member-growth-data?from_date=${fromDate}&to_date=${toDate}&period=${period}`
  );
};

export const useMemberGrowth = ({
  churchId,
  fromDate,
  toDate,
  period,
  config
} = {}) => {
  return useQuery({
    ...config,
    queryKey: ["member-growth", churchId, fromDate, toDate, period],
    queryFn: () => getMemberGrowth({ churchId, fromDate, toDate, period }),
    select: response => response.result,
    refetchOnMount: true,
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
    staleTime: 0,
    cacheTime: 0
  });
};
